/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="70.86"
        height="93.74"
        viewBox="0 0 70.86 93.74"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M35.33 73.5h5.23a1 1 0 0 0 1-1 .76.76 0 0 0 0-.21l-3-13a1.11 1.11 0 0 1 0-.19.89.89 0 0 1 .41-.75 6.65 6.65 0 1 0-7 0 .87.87 0 0 1 .41.75 1.11 1.11 0 0 1 0 .19l-3 13a1.49 1.49 0 0 0 0 .21 1 1 0 0 0 1 1h5Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M44.69 0a10.46 10.46 0 0 1 10.45 10.13v17a1.24 1.24 0 0 1-1.25 1.25 1.26 1.26 0 0 1-1.25-1.12V10.41a8 8 0 0 0-7.7-7.91H26.17a8 8 0 0 0-8 7.67v17a1.25 1.25 0 0 1-2.49.13V10.41A10.47 10.47 0 0 1 25.89 0h18.8Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M66.38 25.92H4.48A4.49 4.49 0 0 0 0 30.4v58.85a4.5 4.5 0 0 0 4.48 4.49h61.9a4.49 4.49 0 0 0 4.48-4.49V30.4a4.49 4.49 0 0 0-4.48-4.48Zm-61.9 2.5h61.9a2 2 0 0 1 2 2v58.85a2 2 0 0 1-2 2H4.48a2 2 0 0 1-2-2V30.4a2 2 0 0 1 2-1.98Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PadlockEngagedIcon';

export default Icon;
